import LoginFormAdmin from "../_misc/components/LoginFormAdmin";

export default function Login() {
    return (
        <section className='w-screen h-screen grid place-content-center overflow-hidden'>
            <LoginFormAdmin />
        </section>
    )
}
